// Base Paths
export const BASE_PATHS = {
  ALGOS_AND_DS: "/algos-and-ds",
  PROGRAMMING_CONTENT: "/programming-content",
  ADMIN_PROBLEMS: "/admin/problems",
  ADMIN_PROGRAMMING_CONTENT: "/admin/programming-content",
  USER: "/user",
  REPORT: "/report",
  ADMIN_USERS: "/admin/users",
  ADMIN_PLANS: "/admin/premium-plans",
  ADMIN_REPORTS: "/admin/reports",
  ADMIN_USER_PROBLEM_SUBMISSIONS: "/admin/user-problem-submissions",
  ADMIN_USER_PLANS: "/admin/user-plans",
  ADMIN_USER_STREAKS: "/admin/user-streaks",
  TAGS: "/tags",
  CANCELLATION_REFUND_POLICY: "/cancellation-refund-policy",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  CONTACT_US: "/contact-us",
  ABOUT_US: "/about-us",
  ADMIN_PROBLEM_LISTS: "/admin/problem-lists",
};

// Path Segments
export const SUB_PATHS = {
  // Admin Segments

  ADD_PROBLEM: "add-problem",
  UPDATE_PROBLEM: "update-problem",
  ADD_CONTENT: "add-content",
  UPDATE_CONTENT: "update-content",
  ADD_USER: "add-user",
  UPDATE_USER: "update-user",
  ADD_PLAN: "add-plan",
  UPDATE_PLAN: "update-plan",
  PREMIUM_PLAN_PURCHASE_DETAILS: "premium-plan-purchase-details",
  ADD_PREMIUM_PLAN_PURCHASE_DETAILS: "add-purchase-details",
  ADD_REPORT: "add-report",
  UPDATE_REPORT: "update-report",
  ADD_USER_PROBLEM_SUBMISSION: "add-submission",
  UPDATE_USER_PROBLEM_SUBMISSION: "update-submission",
  ADD_USER_PLAN: "add-user-plan",
  UPDATE_USER_PLAN: "update-user-plan",
  ADD_TAG: "add-tag",
  UPDATE_TAG: "update-tag",
  ADD_USER_STREAK: "add-user-streak",
  UPDATE_USER_STREAK: "update-user-streak",
  ADD_PROBLEM_LIST: "add-problem-list",
  UPDATE_PROBLEM_LIST: "update-problem-list",

  // Not Authenticated Segments
  LOGIN: "/signin",
  SIGNUP: "/signup",
  VERIFY_ACCOUNT: "/verify-account",
  CONFIRM_ACCOUNT: "/confirm-account",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_FORGOT_PASSWORD: "/reset-forgot-password",
  UPGRADE: "/upgrade",
  PROFILE: "/profile",
  ACTIVATE: "/activate",
};

// Route Definitions
export const ROUTES = {
  // Public Routes
  HOME: "/",
  ERROR_404: "/*",

  // Authenticated Routes
  USER_HOME: "/home",
  USER_PROFILE: `${BASE_PATHS.USER}${SUB_PATHS.PROFILE}`,
  ALGOS_AND_DS: BASE_PATHS.ALGOS_AND_DS,
  ALGOS_AND_DS_DETAIL: `${BASE_PATHS.ALGOS_AND_DS}/:name`,
  PROGRAMMING_CONTENT: BASE_PATHS.PROGRAMMING_CONTENT,
  PROGRAMMING_CONTENT_LANGUAGE: `${BASE_PATHS.PROGRAMMING_CONTENT}/:language`,
  PROGRAMMING_CONTENT_LANGUAGE_URL: `${BASE_PATHS.PROGRAMMING_CONTENT}/:language/:url`,
  REPORT: BASE_PATHS.REPORT,

  // Admin Routes
  ADMIN_PROBLEMS: BASE_PATHS.ADMIN_PROBLEMS,
  ADMIN_PROBLEMS_ADD: `${BASE_PATHS.ADMIN_PROBLEMS}/${SUB_PATHS.ADD_PROBLEM}`,
  ADMIN_PROBLEMS_DETAIL: `${BASE_PATHS.ADMIN_PROBLEMS}/:id`,
  ADMIN_PROBLEMS_UPDATE: `${BASE_PATHS.ADMIN_PROBLEMS}/${SUB_PATHS.UPDATE_PROBLEM}/:id`,
  ADMIN_PROGRAMMING_CONTENT: BASE_PATHS.ADMIN_PROGRAMMING_CONTENT,
  ADMIN_PROGRAMMING_CONTENT_ADD: `${BASE_PATHS.ADMIN_PROGRAMMING_CONTENT}/${SUB_PATHS.ADD_CONTENT}`,
  ADMIN_PROGRAMMING_CONTENT_DETAIL: `${BASE_PATHS.ADMIN_PROGRAMMING_CONTENT}/:id`,
  ADMIN_PROGRAMMING_CONTENT_UPDATE: `${BASE_PATHS.ADMIN_PROGRAMMING_CONTENT}/${SUB_PATHS.UPDATE_CONTENT}/:id`,
  ADMIN_PROGRAMMING_CONTENT_MANAGE: BASE_PATHS.ADMIN_PROGRAMMING_CONTENT,
  ADMIN_USERS: BASE_PATHS.ADMIN_USERS,
  ADMIN_USERS_ADD: `${BASE_PATHS.ADMIN_USERS}/${SUB_PATHS.ADD_USER}`,
  ADMIN_USERS_DETAIL: `${BASE_PATHS.ADMIN_USERS}/:id`,
  ADMIN_USERS_UPDATE: `${BASE_PATHS.ADMIN_USERS}/${SUB_PATHS.UPDATE_USER}/:id`,
  ADMIN_PLANS: BASE_PATHS.ADMIN_PLANS,
  ADMIN_PLANS_ADD: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.ADD_PLAN}`,
  ADMIN_PLANS_DETAIL: `${BASE_PATHS.ADMIN_PLANS}/:id`,
  ADMIN_PLANS_UPDATE: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.UPDATE_PLAN}/:id`,
  ADMIN_PAYMENTS: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.PREMIUM_PLAN_PURCHASE_DETAILS}`,
  ADMIN_PAYMENTS_DETAIL: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.PREMIUM_PLAN_PURCHASE_DETAILS}/:id`,
  ADMIN_PAYMENTS_UPDATE: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.PREMIUM_PLAN_PURCHASE_DETAILS}/${SUB_PATHS.UPDATE_PLAN}/:id`,
  ADMIN_PAYMENTS_ADD: `${BASE_PATHS.ADMIN_PLANS}/${SUB_PATHS.ADD_PREMIUM_PLAN_PURCHASE_DETAILS}`,
  ADMIN_REPORTS: BASE_PATHS.ADMIN_REPORTS,
  ADMIN_REPORTS_ADD: `${BASE_PATHS.ADMIN_REPORTS}/${SUB_PATHS.ADD_REPORT}`,
  ADMIN_REPORTS_UPDATE: `${BASE_PATHS.ADMIN_REPORTS}/${SUB_PATHS.UPDATE_REPORT}/:id`,
  ADMIN_REPORTS_DETAIL: `${BASE_PATHS.ADMIN_REPORTS}/:id`,
  ADMIN_USER_PROBLEM_SUBMISSIONS: `${BASE_PATHS.ADMIN_USER_PROBLEM_SUBMISSIONS}`,
  ADMIN_USER_PROBLEM_SUBMISSIONS_ADD: `${BASE_PATHS.ADMIN_USER_PROBLEM_SUBMISSIONS}/${SUB_PATHS.ADD_USER_PROBLEM_SUBMISSION}`,
  ADMIN_USER_PROBLEM_SUBMISSIONS_UPDATE: `${BASE_PATHS.ADMIN_USER_PROBLEM_SUBMISSIONS}/${SUB_PATHS.UPDATE_USER_PROBLEM_SUBMISSION}/:id`,
  ADMIN_USER_PLANS: `${BASE_PATHS.ADMIN_USER_PLANS}`,
  ADMIN_USER_PLANS_ADD: `${BASE_PATHS.ADMIN_USER_PLANS}/${SUB_PATHS.ADD_USER_PLAN}`,
  ADMIN_USER_PLANS_UPDATE: `${BASE_PATHS.ADMIN_USER_PLANS}/${SUB_PATHS.UPDATE_USER_PLAN}/:id`,

  ADMIN_USER_STREAKS: `${BASE_PATHS.ADMIN_USER_STREAKS}`,
  ADMIN_USER_STREAKS_ADD: `${BASE_PATHS.ADMIN_USER_STREAKS}/${SUB_PATHS.ADD_USER_STREAK}`,
  ADMIN_USER_STREAKS_UPDATE: `${BASE_PATHS.ADMIN_USER_STREAKS}/${SUB_PATHS.UPDATE_USER_STREAK}/:id`,
  ADMIN_USER_STREAKS_DETAIL: `${BASE_PATHS.ADMIN_USER_STREAKS}/:id`,

  ADMIN_PROBLEM_LISTS: `${BASE_PATHS.ADMIN_PROBLEM_LISTS}`,
  ADMIN_PROBLEM_LISTS_ADD: `${BASE_PATHS.ADMIN_PROBLEM_LISTS}/${SUB_PATHS.ADD_PROBLEM_LIST}`,
  ADMIN_PROBLEM_LISTS_UPDATE: `${BASE_PATHS.ADMIN_PROBLEM_LISTS}/${SUB_PATHS.UPDATE_PROBLEM_LIST}/:id`,
  ADMIN_PROBLEM_LISTS_DETAIL: `${BASE_PATHS.ADMIN_PROBLEM_LISTS}/:id`,

  // Not Authenticated Routes
  USER_LOGIN: `${BASE_PATHS.USER}${SUB_PATHS.LOGIN}`,
  USER_SIGNUP: `${BASE_PATHS.USER}${SUB_PATHS.SIGNUP}`,
  USER_ACTIVATE: `${BASE_PATHS.USER}${SUB_PATHS.ACTIVATE}/:key`,
  UPGRADE: `${SUB_PATHS.UPGRADE}`,
  UPGRADE_DETAIL: `${SUB_PATHS.UPGRADE}/:id`,
  USER_VERIFY_ACCOUNT: `${BASE_PATHS.USER}${SUB_PATHS.VERIFY_ACCOUNT}`,
  USER_CONFIRM_ACCOUNT: `${BASE_PATHS.USER}${SUB_PATHS.CONFIRM_ACCOUNT}`,
  USER_FORGOT_PASSWORD: `${BASE_PATHS.USER}${SUB_PATHS.FORGOT_PASSWORD}`,
  USER_RESET_FORGOT_PASSWORD: `${BASE_PATHS.USER}${SUB_PATHS.RESET_FORGOT_PASSWORD}/:key`,
  TAGS: `${BASE_PATHS.TAGS}`,
  TAGS_ADD: `${BASE_PATHS.TAGS}/${SUB_PATHS.ADD_TAG}`,
  TAGS_UPDATE: `${BASE_PATHS.TAGS}/${SUB_PATHS.UPDATE_TAG}/:id`,
  TAGS_DETAIL: `${BASE_PATHS.TAGS}/:id`,
  CANCELLATION_REFUND_POLICY: `${BASE_PATHS.CANCELLATION_REFUND_POLICY}`,
  PRIVACY_POLICY: `${BASE_PATHS.PRIVACY_POLICY}`,
  TERMS_AND_CONDITIONS: `${BASE_PATHS.TERMS_AND_CONDITIONS}`,
  CONTACT_US: `${BASE_PATHS.CONTACT_US}`,
  ABOUT_US: `${BASE_PATHS.ABOUT_US}`,
};

export const ROUTES_FOR_AUTHENTICATED = [
  ROUTES.USER_HOME,
  ROUTES.ALGOS_AND_DS,
  ROUTES.ALGOS_AND_DS_DETAIL,
  ROUTES.PROGRAMMING_CONTENT,
  ROUTES.PROGRAMMING_CONTENT_LANGUAGE,
  ROUTES.PROGRAMMING_CONTENT_LANGUAGE_URL,
  ROUTES.TAGS,
];

export const ROUTES_FOR_ADMIN = [
  ROUTES.ADMIN_PROBLEMS_ADD,
  ROUTES.ADMIN_PROBLEMS,
  ROUTES.ADMIN_PROBLEMS_DETAIL,
  ROUTES.ADMIN_PROBLEMS_UPDATE,
  ROUTES.ADMIN_PROGRAMMING_CONTENT_ADD,
  ROUTES.ADMIN_PROGRAMMING_CONTENT_UPDATE,
  ROUTES.ADMIN_PROGRAMMING_CONTENT_MANAGE,
  ROUTES.ADMIN_USERS,
  ROUTES.ADMIN_USERS_ADD,
  ROUTES.ADMIN_USERS_DETAIL,
  ROUTES.ADMIN_USERS_UPDATE,
  ROUTES.ADMIN_PLANS,
  ROUTES.ADMIN_PLANS_ADD,
  ROUTES.ADMIN_PLANS_DETAIL,
  ROUTES.ADMIN_PLANS_UPDATE,
  ROUTES.ADMIN_PAYMENTS,
  ROUTES.ADMIN_PAYMENTS_DETAIL,
  ROUTES.ADMIN_PAYMENTS_UPDATE,
  ROUTES.ADMIN_PAYMENTS_ADD,
  ROUTES.ADMIN_REPORTS,
  ROUTES.ADMIN_REPORTS_DETAIL,
  ROUTES.ADMIN_REPORTS_UPDATE,
  ROUTES.ADMIN_REPORTS_ADD,
  ROUTES.ADMIN_USER_PROBLEM_SUBMISSIONS,
  ROUTES.ADMIN_USER_PROBLEM_SUBMISSIONS_ADD,
  ROUTES.ADMIN_USER_PROBLEM_SUBMISSIONS_UPDATE,
  ROUTES.ADMIN_USER_PLANS,
  ROUTES.ADMIN_USER_PLANS_ADD,
  ROUTES.ADMIN_USER_PLANS_UPDATE,
  ROUTES.TAGS,
  ROUTES.TAGS_ADD,
  ROUTES.TAGS_UPDATE,
  ROUTES.TAGS_DETAIL,
];

export const ROUTES_FOR_NOT_AUTHENTICATED = [
  ROUTES.USER_LOGIN,
  ROUTES.USER_SIGNUP,
  ROUTES.USER_VERIFY_ACCOUNT,
  ROUTES.USER_CONFIRM_ACCOUNT,
  ROUTES.USER_FORGOT_PASSWORD,
  ROUTES.UPGRADE,
  ROUTES.UPGRADE_DETAIL,
];
